module.exports = __webpack_public_path__ + "static/img/logo.3c8bf56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 54